import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Login from './components/Login';
import PasswordForgot from './components/PasswordForgot';
import PasswordReset from './components/PasswordReset';
import Registration from './components/Registration';

export function App() {
  return (
    <Router>
      <Route path="/registrations/new" component={Registration} />
      <Route path="/login" component={Login} />
      <Route path="/forgot_password/new" component={PasswordForgot} />
      <Route path="/password_resets/*" component={PasswordReset} />

      <Route exact path="/registration-next" component={Registration} />
      <Route
        path="/registration-next/password_resets/*"
        component={PasswordReset}
      />
    </Router>
  );
}

export default App;
